import React, { useCallback } from 'react';
import Button from '@atlaskit/button';
import type { Size } from '@atlaskit/icon';
import CrossIcon from '@atlaskit/icon/glyph/cross';
import { useIntl } from '@atlassian/jira-intl';
// eslint-disable-next-line jira/import/no-restricted-paths
import { useSource } from '../../../controllers/import-state/selectors/source';
// eslint-disable-next-line jira/import/no-restricted-paths
import { useCancelImportModalState } from '../../../controllers/ui-state';
import { CROSS_FLOW } from '../../constants/source';
import { redirectToProjectTemplatesScreen } from '../../utils';
import messages from './messages';

export type CloseAndReturnButtonProps = {
	onCloseAndReturnToUploadStep: () => void;
	shouldShowCancelModal?: boolean;
	iconOnly?: boolean;
	iconSize?: Size;
};

export const CloseAndReturnButton = ({
	onCloseAndReturnToUploadStep,
	shouldShowCancelModal = true,
	iconOnly = false,
	iconSize = 'small',
}: CloseAndReturnButtonProps) => {
	const { formatMessage } = useIntl();
	const [, { setCancelImportModalState }] = useCancelImportModalState();
	const [source] = useSource();

	const onCloseModalCallback = useCallback(() => {
		// Remove this when the new project create integration is implemented
		source === CROSS_FLOW ? redirectToProjectTemplatesScreen() : onCloseAndReturnToUploadStep();
	}, [onCloseAndReturnToUploadStep, source]);

	const handleOpenCancelImport = useCallback(() => {
		setCancelImportModalState({
			isCancelImportModalOpen: true,
			shouldCloseDrawerOnCancel: false,
			onCloseModalCallback,
		});
	}, [onCloseModalCallback, setCancelImportModalState]);

	return (
		<Button
			testId="project-create-importer-upload-flow.common.ui.close-and-return-button.return-button"
			onClick={shouldShowCancelModal ? handleOpenCancelImport : onCloseModalCallback}
			appearance="subtle"
			iconBefore={<CrossIcon label="" size={iconSize} />}
			aria-label={messages.closeAndReturn.defaultMessage}
		>
			{source !== CROSS_FLOW && !iconOnly && formatMessage(messages.closeAndReturn)}
		</Button>
	);
};
